export default {
  STATUS: [
    { KEY: 0, VALUE: 'NÃO UTILIZADO' },
    { KEY: 1, VALUE: 'EXPIRADO' },
    { KEY: 2, VALUE: 'UTILIZADO' },
  ],
  REVERSED: { KEY: 3, VALUE: 'ESTORNADO' },
};
